import { useEffect } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";

export const PageShell = ({ title, children }) => {
  useEffect(() => {
    document.title = title
      ? `${title} | Mary Pawpins Pet Care`
      : "Mary Pawpins Pet Care | Inverness Dog Walking & Pet Sitting";
  }, [title]);

  return (
    <div>
      <Header />
      <main>{children}</main>
      <Footer />
    </div>
  );
};
